export type InpostPayEnvironment = 'sandbox' | 'uat' | 'production'

export interface InpostPayConfig {
  merchantClientId: string
  bindingApiKey: string | null
  apiBaseUrl: string
  widgetScriptUrl: string
  environment: InpostPayEnvironment
  needsCart: boolean
}

export interface InpostPayConfirmationUrl {
  url: string
  // orderId wyłuskany z URL (id_order) przez server route; null gdy nieobecny w linku.
  orderId?: string | null
}

export interface InpostPayOrderCreatedEvent {
  orderId: string
  orderReference?: string
}

const ENV_VALUES: ReadonlySet<InpostPayEnvironment> = new Set(['sandbox', 'uat', 'production'])

export function isInpostPayConfig(value: unknown): value is InpostPayConfig {
  if (!value || typeof value !== 'object') return false
  const v = value as Record<string, unknown>
  if (typeof v.merchantClientId !== 'string') return false
  if (v.bindingApiKey !== null && typeof v.bindingApiKey !== 'string') return false
  if (typeof v.apiBaseUrl !== 'string' || v.apiBaseUrl.length === 0) return false
  if (typeof v.widgetScriptUrl !== 'string' || !v.widgetScriptUrl.startsWith('http')) return false
  if (typeof v.environment !== 'string' || !ENV_VALUES.has(v.environment as InpostPayEnvironment)) return false
  if (typeof v.needsCart !== 'boolean') return false
  // Empty merchantClientId only allowed when needsCart=true (cart not yet created)
  if (v.merchantClientId.length === 0 && v.needsCart !== true) return false
  return true
}

export function isInpostPayConfirmationUrl(value: unknown): value is InpostPayConfirmationUrl {
  if (!value || typeof value !== 'object') return false
  const v = value as Record<string, unknown>
  return typeof v.url === 'string' && v.url.length > 0
}
